module.exports = __webpack_public_path__ + "img/res2.c09d5814.png";